
import Vue from 'vue'
import Marquees from '@/components/Marquees.vue';
import WorkspaceCard from '@/components/WorkspaceCard.vue';
export default Vue.extend({
    name: 'Contact',
    components: {
        Marquees,
        WorkspaceCard
    },
    data() {
        return {
            knwlImg: [
                'knwl-logo-1.png',
                'knwl-logo-2.png',
                'knwl-logo-3.png',
                'knwl-logo-4.png',
            ],
            toolImg: [
                'tool-logo-1.png',
                'tool-logo-2.png',
                'tool-logo-3.png',
                'tool-logo-4.png',
            ],
            botImg: [
                'bot-logo-1.png',
                'bot-logo-2.png',
                'bot-logo-3.png',
                'bot-logo-4.png',
            ],
            workspaceList:[
                {
                    src: 'less-hallucination.png',
                    title: 'Less Hallucination',
                    text: 'We develop our proprietary LLMops evaluation pipeline to make sure AI doesn’t hallucinate.'
                },
                {
                    src: 'multimodal.png',
                    title: 'Multimodal',
                    text: 'Handle text, voice, and image inputs seamlessly, offering a richer, more flexible user experience.',
                },
                {
                    src: 'devOps-focus.png',
                    title: 'DevOps Focus',
                    text: 'Streamline your entire software lifecycle. One-click versioning, deployment, and performance optimization tailored for developers.',
                },
                {
                    src: 'secure-access.png',
                    title: 'Secure Access',
                    text: 'OAuth2 integration ensures robust, standardized security across all your applications.',
                },
                {
                    src: 'event-driven.png',
                    title: 'Event-driven',
                    text: 'AI reacts instantly to real-time events, enabling dynamic decision-making without manual intervention.',
                },
                {
                    title: 'DevOps Friendly!'
                }
            ]
        }
    },
    methods: {
        
    }
})
